import type { UsuarioLogadoInterface } from 'store/reducers/usuarios';

export type CoreMeResponse = {
  id: string;
  nome: string;
  apelido: string;
  email: string;
  profilePicture?: string;
  available: boolean;
  flagCanTranscribeAudio: boolean;
  // Opcionais por segurança: um campo ausente não pode derrubar o carregamento da sessão
  ratings?: {
    averageRating: number;
    totalRatings: number;
  };
  is_access_admin: boolean;
  is_access_chat: boolean;
  isInternalSupport: boolean;
  accessProfile?: {
    isAdmin: boolean;
    alias: string;
    permissions: string[];
  };
  accessModules?: {
    isAccessGroup: boolean;
  };
  tenant?: {
    id: string;
    name: string;
  };
};

export function mapCoreUser(me: CoreMeResponse): UsuarioLogadoInterface {
  return {
    id: me.id,
    nome: me.nome,
    apelido: me.apelido,
    email: me.email,
    foto: me.profilePicture,
    disponivel: me.available,
    avaliacoes: {
      nota_media: me.ratings?.averageRating ?? 0,
      total_avaliacoes: me.ratings?.totalRatings ?? 0,
    },
    is_access_admin: me.is_access_admin,
    is_access_chat: me.is_access_chat,
    is_suporte_interno: me.isInternalSupport,
    acessos: {
      is_admin: me.accessProfile?.isAdmin ?? false,
      permissoes: me.accessProfile?.permissions ?? [],
      alias: me.accessProfile?.alias as 'admin' | 'supervisor',
    },
    modulos: {
      is_access_grupo_modulo: me.accessModules?.isAccessGroup ?? false,
      can_transcribe_audio: me.flagCanTranscribeAudio,
    },
    tenant: me.tenant && {
      id: me.tenant.id,
      nome: me.tenant.name,
    },
  };
}
